import styled, { css } from 'styled-components';
import { Flex, mediaMixin, spaceMixin, token } from '@zillow/constellation';

import MediumIllustrationHouse1x from '../../../images/MediumIllustrationHouse@1x.png';
import MediumIllustrationHouse2x from '../../../images/MediumIllustrationHouse@2x.png';

export const StyledComponent = styled.div`
  /* reset from conflicting class */
  &.Review {
    border: none;
    padding: 0;
    margin-bottom: 75px;
  }
`;

export const StyledDesktopFlex = styled(Flex)`
  ${mediaMixin(
    'sm_lte',
    css`
      display: none;
    `,
  )}
`;

export const StyledMobileFlex = styled(Flex)`
  ${mediaMixin(
    'md',
    css`
      display: none;
    `,
  )}
`;

export const StyledPreviewListingCTAFlex = styled(Flex)`
  max-width: 152px;
`;

export const StyledRentalProtectionBannerCtaContainer = styled.div`
  ${mediaMixin(
    'md',
    css`
      margin-left: auto;
    `,
  )}
`;

type StyledPropertyPhotoContainerProps = { primaryPhotoUrl: string };
export const StyledPropertyPhotoContainer = styled.div<StyledPropertyPhotoContainerProps>`
  background-color: ${token('colors.aqua600')};
  background-image: url(${(props) => props.primaryPhotoUrl || MediumIllustrationHouse2x});
  background-position: center center;
  background-repeat: no-repeat;
  background-size: ${(props) => (props.primaryPhotoUrl ? 'cover' : '70px')};
  border-radius: ${spaceMixin(0.5)};
  margin-right: ${spaceMixin('xs')};
  width: 93px;

  ${mediaMixin(
    'md',
    css<StyledPropertyPhotoContainerProps>`
      background-image: url(${(props) => (props.primaryPhotoUrl ? props.primaryPhotoUrl : MediumIllustrationHouse1x)});
      background-size: ${(props) => (props.primaryPhotoUrl ? 'cover' : '105px')};
      width: 156px;
      margin-right: ${spaceMixin('sm')};
    `,
  )}
`;

export const StyledReviewSection = styled.div`
  margin-bottom: ${spaceMixin('lg')};
`;

export const StyledReviewTitleRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  margin-bottom: ${spaceMixin('sm')};
`;

export const StyledIconPlaceholder = styled.div`
  display: inline-block;
  margin-right: 8px;
  width: 15px;
  max-height: 15px;

  flex-shrink: 0;
`;

export const StyledUnorderedList = styled.ul`
  list-style: none;
`;

export const StyledListItem = styled.li`
  display: inline;
`;

// ZRM-10673 - wrapped property card overview items in list for accessibility
// this needs to be <li/> to comply with its parent <ul/>
export const StyledVerticalDivider = styled.li`
  align-self: center;
  background-color: ${token('colors.gray400')};
  display: inline-flex;
  height: 12px;
  margin: 0 ${spaceMixin(0.5)};
  width: 1px;

  ${mediaMixin(
    'md',
    css`
      margin: 0 ${spaceMixin('xs')};
    `,
  )}
`;
